"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spotify2Schema = void 0;
exports.Spotify2Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/spotify-audio/2.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Spotify2",
    "description": "Add a spotify play button",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:spotify-audio:2"
            ]
        },
        "attributes": {
            "type": "object",
            "oneOf": [
                {
                    "required": [
                        "assetType",
                        "href"
                    ]
                },
                {
                    "required": [
                        "assetType",
                        "uri"
                    ]
                }
            ],
            "properties": {
                "assetType": {
                    "type": "string",
                    "enum": [
                        "album",
                        "artist",
                        "episode",
                        "playlist",
                        "show",
                        "track"
                    ]
                },
                "href": {
                    "type": "string",
                    "description": "Spotify URL (https://play.spotify.com/track/0ZSdQvYFSY7BNjJEB6t0P3)",
                    "pattern": "^((http|https):/{2})(([0-9a-z_-]+[.])+)com.*$"
                },
                "uri": {
                    "type": "string",
                    "description": "A spotify URI, e.g. spotify:artist:5lsC3H1vh9YSRQckyGv0Up",
                    "pattern": "^(spotify:).*$"
                }
            }
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMi5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zcG90aWZ5LWF1ZGlvLzIuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsY0FBYyxHQUFHO0lBQzVCLEtBQUssRUFBRSxrRkFBa0Y7SUFDekYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsVUFBVTtJQUNuQixhQUFhLEVBQUUsMkJBQTJCO0lBQzFDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiwwQ0FBMEM7YUFDM0M7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE9BQU8sRUFBRTtnQkFDUDtvQkFDRSxVQUFVLEVBQUU7d0JBQ1YsV0FBVzt3QkFDWCxNQUFNO3FCQUNQO2lCQUNGO2dCQUNEO29CQUNFLFVBQVUsRUFBRTt3QkFDVixXQUFXO3dCQUNYLEtBQUs7cUJBQ047aUJBQ0Y7YUFDRjtZQUNELFlBQVksRUFBRTtnQkFDWixXQUFXLEVBQUU7b0JBQ1gsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRTt3QkFDTixPQUFPO3dCQUNQLFFBQVE7d0JBQ1IsU0FBUzt3QkFDVCxVQUFVO3dCQUNWLE1BQU07d0JBQ04sT0FBTztxQkFDUjtpQkFDRjtnQkFDRCxNQUFNLEVBQUU7b0JBQ04sTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxxRUFBcUU7b0JBQ3BGLFNBQVMsRUFBRSwrQ0FBK0M7aUJBQzNEO2dCQUNELEtBQUssRUFBRTtvQkFDTCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLDJEQUEyRDtvQkFDMUUsU0FBUyxFQUFFLGdCQUFnQjtpQkFDNUI7YUFDRjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9